import { render, staticRenderFns } from "./widget-close-svg.vue?vue&type=template&id=6b89d87c&scoped=true&"
var script = {}
import style0 from "./widget-close-svg.vue?vue&type=style&index=0&id=6b89d87c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b89d87c",
  null
  
)

export default component.exports